import { ArAgentView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useArHold } from '../hooks/useArHold';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * AI Team › Accounts receivable — rebuilt (amendment 28 §3). The read-only work
 * stream: the funnel lives on Collections › Balances, so the hero here is what
 * was collected. AI calls stay. Hold works as Recall's.
 */
export function ArCoordinatorPage() {
  const navigate = useNavigate();
  const { onHold, setHold } = useArHold();
  const [period, setPeriod] = usePeriodRange();
  return (
    <ArAgentView
      onHold={onHold}
      onSetHold={setHold}
      period={period}
      onPeriodChange={setPeriod}
      onOpenCollections={() => { void navigate('/collections/follow-ups'); }}
      onOpenSettings={() => { void navigate('/settings/ai/accounts-receivable'); }}
      onOpenTriage={() => { void navigate('/triage?source=accounts-receivable'); }}
      onOpenCalls={() => { void navigate('/calls?type=balance'); }}
      onOpenFollowUps={() => { void navigate('/collections/follow-ups'); }}
      onOpenCommLog={() => { void navigate('/communications?agent=accounts-receivable'); }}
    />
  );
}
